const cadastro_de_turma_de_atendimento_educacional_especializado = [
  {
    path: "/cadastro-de-turma-de-atendimento-educacional-especializado",
    redirect: "/cadastro-de-turma-de-atendimento-educacional-especializado",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/cadastro-de-turma-de-atendimento-educacional-especializado",
        name: "cadastro_de_turma_de_atendimento_educacional_especializado",
        component: () =>
          import(
            "@/views/CadastroDeTurmaDeAtendimentoEducacionalEspecializado/CadastroDeTurmaDeAtendimentoEducacionalEspecializadoHome.vue"
          ),
      },
      {
        path: "/cadastro-de-turma-de-atendimento-educacional-especializado/novo",
        name: "cadastro_de_turma_de_atendimento_educacional_especializado_novo",
        component: () =>
          import(
            "@/views/CadastroDeTurmaDeAtendimentoEducacionalEspecializado/CadastroDeTurmaDeAtendimentoEducacionalEspecializadoNovo.vue"
          ),
      },
      {
        path: "/cadastro-de-turma-de-atendimento-educacional-especializado/:id/editar",
        name: "cadastro_de_turma_de_atendimento_educacional_especializado_editar",
        component: () =>
          import(
            "@/views/CadastroDeTurmaDeAtendimentoEducacionalEspecializado/CadastroDeTurmaDeAtendimentoEducacionalEspecializadoEditar.vue"
          ),
      },
      {
        path: "/cadastro-de-turma-de-atendimento-educacional-especializado-lista-alunos/:id",
        name: "cadastro_de_turma_de_atendimento_educacional_especializado_lista_alunos",
        component: () =>
          import(
            "@/views/CadastroDeTurmaDeAtendimentoEducacionalEspecializado/CadastroDeTurmaDeAtendimentoEducacionalEspecializadoList.vue"
          ),
      },
    ],
  },
];

export { cadastro_de_turma_de_atendimento_educacional_especializado };
